<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="m22.8 17.4-5.2 5.3c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-2.8-2.8c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.1 2.1 4.5-4.5c.4-.4 1-.4 1.4 0 .3.3.3.9 0 1.3z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M18.6 2.9h-1v-.4c0-.8-.7-1.5-1.5-1.5H6c-.8 0-1.5.7-1.5 1.5v.4h-1C2.1 2.9 1 4 1 5.4v15.1C1 21.9 2.1 23 3.5 23h8.2c.6 0 1-.4 1-1s-.4-1-1-1H3.5c-.3 0-.5-.2-.5-.5V5.4c0-.3.2-.5.5-.5h1v.4c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5v-.4h1c.3 0 .5.2.5.5v7.9c0 .6.4 1 1 1s1-.4 1-1V5.4c.1-1.4-1-2.5-2.4-2.5zm-3 1.9h-9V3h9v1.8z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M15.2 11.6H6.9c-.6 0-1-.4-1-1s.4-1 1-1h8.3c.6 0 1 .4 1 1s-.4 1-1 1zm-4.4 4.5H7.2c-.6 0-1-.4-1-1s.4-1 1-1h3.6c.6 0 1 .4 1 1s-.5 1-1 1z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
